import { useTranslation } from "react-i18next";
import Icon from "../image/Icon";
import { ModalBtn } from "./ModalBtn";
export const OkCancelPopup = ({
  isLoading,
  title,
  ic,
  onOk,
  onCancel,
  okText,
  cancelText,
  children,
  footerText,
  okStyle,
}: {
  onOk?: () => void;
  okText?: string;
  cancelText?: string;
  onCancel?: () => void;
  isLoading?: boolean;
  title?: string;
  ic?: string;
  children?: React.ReactNode;
  footerText?: string;
  okStyle?: "cancel" | "primary" | "loading" | "md" | boolean | undefined;
}) => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-[22.5rem] max-w-3xl rounded-[1rem] border border-[#D7DCE3] bg-white p-8 text-center shadow-lg">
        <div className="flex flex-col items-center gap-6">
          {ic && <Icon className="size-12 object-cover" src={ic} />}
          <div className="flex w-full flex-col gap-2">
            <h2 className="w-full whitespace-pre-wrap break-words text-[1.125rem] font-semibold leading-[1.625rem] text-[#232323]">
              {title}
            </h2>
            {children}
          </div>
          <div className="flex w-full justify-end gap-4">
            {onCancel && (
              <ModalBtn opts={["cancel"]} onClick={() => onCancel?.()}>
                {cancelText || t("Cancel")}
              </ModalBtn>
            )}
            <ModalBtn
              opts={[okStyle ?? "primary", isLoading && "loading"]}
              onClick={onOk}
            >
              {okText || t("Ok")}
            </ModalBtn>
          </div>
          {footerText && (
            <div className="flex w-full justify-start border-t border-[#D7DCE3] pt-6 text-[0.75rem] font-normal leading-[1.125rem] text-[#5E6D77]">
              {footerText}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
